import React, { Component } from "react";
import PropTypes from "prop-types";

// This function takes a component and returns a new one.
export default WrappedComponent => {
  class WithModal extends Component {
    constructor(props) {
      super(props);
      this.state = { modalOpen: props.initialModalOpen };
    }

    closeModal() {
      this.setState({ modalOpen: false });
    }

    openModal() {
      this.setState({ modalOpen: true });
    }

    render() {
      return (
        <WrappedComponent
          openModalCallback={() => this.openModal()}
          closeModalCallback={() => this.closeModal()}
          {...this.state}
          {...this.props}
        />
      );
    }
  }

  WithModal.propTypes = {
    initialModalOpen: PropTypes.bool,
  };

  return WithModal;
};
